import { marked } from "marked";
import DOMPurify from "dompurify";
import { UAParser } from "ua-parser-js";

marked.use({
  breaks: true, // break line on a single line break
});

export class Utils {
  static getParamValue(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  static timeFormatted(time = new Date().getTime()) {
    const hours = Math.floor(time / 1000 / 60 / 60);
    const minutes = Math.floor((time / 1000 / 60) % 60);
    const seconds = Math.floor((time / 1000) % 60);
    var timeString = minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");

    if (hours > 0)
      timeString = hours.toString().padStart(2, "0") + ":" + timeString;

    return timeString;
  }


  static isMac() {
    const platform = navigator.userAgentData?.platform ?? navigator.platform ?? "";
    return /mac/i.test(platform);
  }

  static getUserAgentData() {
    return UAParser();
  }

  static async getMediaDevices() {
    let result = [];

    if (!navigator.mediaDevices?.enumerateDevices) {
      console.warn("enumerateDevices() not supported.");
    } else {
      // List cameras and microphones.
      await navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          devices.forEach((device) => {
            result.push(device.label)
          });
        })
        .catch((err) => {
          console.error(`${err.name}: ${err.message}`);
        });
    }

    return result
  }

  static map_range(value, low1, high1, low2, high2) {
    return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
  }

  static markdown(text) {
    if (text == null) {
      return "";
    }

    return DOMPurify.sanitize(marked.parse(String(text)));
  }

  static escapeHtml(text) {
    return String(text)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  // Turns whatever was thrown or dispatched (Error, DOMException, string, null,
  // ErrorEvent, PromiseRejectionEvent, MediaRecorderErrorEvent...) into
  // { name, message, stack }. Never throws.
  static normalizeError(error) {
    try {
      if (error == null) {
        return { name: "Error", message: "Unknown error", stack: "" };
      }

      if (typeof error === "string") {
        return { name: "Error", message: error, stack: "" };
      }

      if (typeof Event !== "undefined" && error instanceof Event) {
        const inner = error.error ?? error.reason;
        if (inner != null) {
          return Utils.normalizeError(inner);
        }

        const where = error.filename ? `${error.filename}:${error.lineno}:${error.colno}` : "";
        return { name: "Error", message: error.message || `${error.type} event`, stack: where };
      }

      return {
        name: String(error.name ?? "Error"),
        message: String(error.message ?? error),
        stack: typeof error.stack === "string" ? error.stack : "",
      };
    } catch (normalizeError) {
      return { name: "Error", message: "Unreadable error", stack: "" };
    }
  }
}
